/** Ruft alle übergebenen Handler nacheinander auf. */
export const chain = (...handlers) => (event) => handlers.forEach((handler) => handler?.(event));

/**
 * dnd-kit-Listener und Vorschau-Handler zusammenführen: gleichnamige Handler laufen beide, statt
 * dass ein Spread den anderen still überschreibt.
 */
export function mergeHandlers(...sources) {
  const merged = {};
  sources.filter(Boolean).forEach((source) => {
    Object.entries(source).forEach(([name, handler]) => {
      merged[name] = merged[name] ? chain(merged[name], handler) : handler;
    });
  });
  return merged;
}
